import { fieldEmail } from './types';

export function flattenEmails(emails: fieldEmail[]): fieldEmail[] {
    return emails.flatMap(email => [email, ...flattenEmails(email.children ?? [])]);
}

export function updateEmailTree(emails: fieldEmail[], id: number | string, changes: Partial<fieldEmail>): fieldEmail[] {
    return emails.map(email => ({
        ...email,
        ...(String(email.id) === String(id) ? changes : {}),
        ...(email.children ? { children: updateEmailTree(email.children, id, changes) } : {}),
    }));
}
